import ChatWidget from './ChatWidget'

export default ChatWidget
